module.exports = __webpack_public_path__ + "static/media/top14FeaturesBanner_Mobile_411x93px_@1x.abfd95bb.jpg";